import { execAdmin } from '@src/apis/reware/utils';

import type {
  PricingRule,
  PricingRuleUpdateInput,
  UpdatePricingRuleExecVariables,
  UpdatePricingRuleExecResponse,
} from './types';

export interface UpdatePricingRuleArgs {
  partnerId: number;
  ruleId: number;
  updates: PricingRuleUpdateInput;
}

export const updatePricingRule = async ({
  partnerId,
  ruleId,
  updates,
}: UpdatePricingRuleArgs): Promise<PricingRule> => {
  const query = `
    mutation updatePricingRule(
      $partnerId: Int!
      $ruleId: Int!
      $updates: PricingRuleUpdateInput!
    ) {
      partner(id: $partnerId) {
        updatePricingRule(
          ruleId: $ruleId
          updates: $updates
        ) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<UpdatePricingRuleExecVariables, UpdatePricingRuleExecResponse>(
    query,
    { variables: { partnerId, ruleId, updates } }
  );

  const result = data.partner?.updatePricingRule;
  if (!result) {
    throw new Error(
      `updatePricingRule: unexpected response — partner.updatePricingRule is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return result;
};
